<template>
  <div class="d-flex flex-row justify-content-between align-items-center mb-4">
    <div class="d-flex flex-column">
      <h2 class="heading-section">{{ ((title ?? this.$route?.meta?.title) ?? this.$route?.name) }}</h2>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
    name: "meta-section",
    props: {
      title: {
        type: String,
        required: false
      },
      description: {
        type: String,
        required: false
      },
    }
}
</script>

<style scoped>
.heading-section {
  font-size: 22px;
  margin-bottom: 0;
  padding-bottom: 0;
  font-weight: 600;
  letter-spacing: 0.2px;
}
</style>